import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import contractUserApi, { isLoggedIn, getEmployeeName, clearToken } from '../../api/contractUserClient';
import './My.css';

export default function MyContracts() {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { loadContracts(); }, []);

  async function loadContracts() {
    try {
      setLoading(true);
      const data = await contractUserApi.get('/contracts/me');
      setContracts(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (!isLoggedIn()) return <Navigate to="/my/login" replace />;

  const handleLogout = () => {
    if (window.confirm('로그아웃하시겠습니까?')) {
      clearToken();
      navigate('/my/login', { replace: true });
    }
  };

  return (
    <div className="my-page">
      <header className="my-page__header">
        <div className="container my-page__header-inner">
          <div>
            <img src="/logo.png" alt="주식회사 허브" className="my-page__logo-img" />
          </div>
          <div className="my-page__header-right">
            <button className="my-logout-btn" onClick={() => navigate('/my/manual')}>매뉴얼</button>
            <span className="text-muted">{getEmployeeName()}님</span>
            <button className="my-logout-btn" onClick={handleLogout}>로그아웃</button>
          </div>
        </div>
      </header>

      <main className="container my-page__content">
        <h1>내 근로계약서</h1>
        <p className="text-muted" style={{ marginBottom: '1.75rem' }}>확인 및 서명이 필요한 근로계약서 목록입니다.</p>

        {loading && <div className="state-message">불러오는 중입니다...</div>}
        {!loading && error && <div className="state-message state-message--error">{error}</div>}

        {!loading && !error && (
          contracts.length === 0 ? (
            <div className="state-message">등록된 근로계약서가 없습니다. 관리자에게 문의해 주세요.</div>
          ) : (
            <div className="my-contract-list">
              {contracts.map(c => (
                <div key={c.id} className="my-contract-card">
                  <div className="my-contract-card__top">
                    <span className={`badge ${c.isSigned ? 'badge-green' : 'badge-accent'}`}>
                      {c.isSigned ? '서명 완료' : '서명 필요'}
                    </span>
                    <span className="text-muted" style={{ fontSize: '0.8rem' }}>
                      발급일 {String(c.contractCreatedAt).slice(0, 10)}
                    </span>
                  </div>
                  <h3>근로계약서</h3>
                  <div className="my-contract-card__info">
                    <span>근무지: {c.workPlace || '-'}</span>
                    <span>근로기간: {c.workPeriodFrom} ~ {c.workPeriodTo}</span>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ marginTop: '1rem' }}
                    onClick={() => navigate(`/my/contracts/${c.id}`)}
                  >
                    {c.isSigned ? '계약서 확인' : '계약서 확인 및 서명하기'}
                  </button>
                </div>
              ))}
            </div>
          )
        )}
      </main>
    </div>
  );
}
